import ContextBrowserModel from './browser.model.js';
import ContextCampaignModel from './campaign.model.js';
import ContextLocaleModel from './contextLocale.model.js';
import ContextEntityIdsModel from './entityIds.model.js';
import ContextGeoModel from './geo.model.js';
import ContextPageModel from './page.model.js';
import ContextStore from './store.model.js';
import ContextTimeModel from './time.model.js';
import ContextUserModel from './user.model.js';
const model = {
    name: 'Context',
    file: 'context',
    buildInterface: true,
    properties: {
        browser: { type: 'model', model: ContextBrowserModel },
        campaign: { type: 'model', model: ContextCampaignModel },
        geo: { type: 'model', model: ContextGeoModel },
        ids: { type: 'map', model: ContextEntityIdsModel, mapKey: 'entity', mapKeyType: 'Entity' },
        locale: { type: 'model', model: ContextLocaleModel },
        page: { type: 'model', model: ContextPageModel },
        store: { type: 'model', model: ContextStore },
        time: { type: 'model', model: ContextTimeModel },
        user: { type: 'model', model: ContextUserModel },
    },
};
export default model;
